import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    CreditAnalyseDemandeDetail,
    CreditFiche,
    CreditObservation,
    GarantiesData,
} from '../../interfaces/credit.interface';
import { CreditService } from '../../services/credit/credit.service';

export interface AnalyseCreditResolvedData {
  fiche: CreditFiche;
  analyse: { demande: CreditAnalyseDemandeDetail };
  observations: CreditObservation[];
  garanties: GarantiesData | null;
}

/**
 * Charge tout ce que la page affiche au premier rendu.
 *
 * Observations et garanties y figurent pour que la page n'ait pas à les
 * redemander une fois montée : elle les pose et n'appelle `refresh()` que
 * lorsque le dossier change vraiment. Les documents n'y figurent pas — la
 * page ne les lit plus ; seuls l'onglet Documents et la barre d'actions en
 * gardent leur propre copie, chacun pour son usage.
 *
 * Les deux listes secondaires encaissent leur échec : une indisponibilité ne
 * doit pas empêcher l'affichage du dossier.
 */
export const analyseCreditResolver: ResolveFn<AnalyseCreditResolvedData> = (
  route: ActivatedRouteSnapshot,
) => {
  const ref = route.paramMap.get('ref')!;
  const svc = inject(CreditService);

  return forkJoin({
    fiche: svc.getFicheCredit(ref),
    analyse: svc.getAnalyseFinanciere(ref),
    observations: svc.getObservations(ref).pipe(catchError(() => of([]))),
    garanties: svc.getGarantiesDemande(ref).pipe(catchError(() => of(null))),
  });
};
